import { Module } from "vuex";
import { RootState } from "../types";
import { MembersInt } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
  error: "",
  data: [],
} as MembersInt;

export const accountMembers: Module<MembersInt, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
